import { render } from "./LieferantBenutzerListe.vue?vue&type=template&id=5ba4b1e6&ts=true"
import script from "./LieferantBenutzerListe.vue?vue&type=script&lang=ts"
export * from "./LieferantBenutzerListe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__